/**
 * Utility function to extract the first error message from API response
 * @param {Object} response - API response object
 * @returns {string} - First error message or default message
 */
export const getFirstErrorMessage = (response) => {
  if (response?.errors?.message != null) {
    // Check if message is an object (Map-like structure)
    if (typeof response.errors.message === 'object' && !Array.isArray(response.errors.message)) {
      const messages = response.errors.message;
      
      for (const key in messages) {
        if (Array.isArray(messages[key]) && messages[key].length > 0) {
          return messages[key][0].toString();
        }
      }
    } 
    // Check if message is a string
    else if (typeof response.errors.message === 'string') {
      return response.errors.message;
    }
  }
  
  return 'Something went wrong.';
};